import admissions from './admissionsReducer';
import casenotes from './casenoteReducer';
import dailyBills from './dailyBillsReducer';

import medicationLogs from './medicationLogReducer';
import prescriptions from './prescriptionReducer';
import nursingNotes from './nursingNoteReducer';
import nursingNotesRecords from './nursingNotesRecordsReducer';
import progressNotes from './progressNoteReducer';
import vitals from './vitalsReducer';
import visitSummary from './visitSummaryReducer';
import labResults from './labResultsReducer';
import referral from './referralReducer';
import pastRecords from './pastRecordsReducer';
import currentAppointment from './currentAppointmentReducer';
import surgeryRecord from './surgeryRecordReducer';
import surgeryOpNotes from './surgeryOpNotesReducer';
import patientUtil from './utilReducer';
import procedures from './proceduresReducers';

export {
  admissions,
  dailyBills,
  medicationLogs,
  casenotes,
  prescriptions,
  nursingNotes,
  progressNotes,
  vitals,
  visitSummary,
  pastRecords,
  labResults,
  referral,
  currentAppointment,
  surgeryRecord,
  surgeryOpNotes,
  patientUtil,
  procedures,
  nursingNotesRecords,
};
